import { takeEvery, fork, put, all, call, takeLatest } from "redux-saga/effects"

//Account Candidate Management
import { CANDIDATE_LIST,CANDIDATE_SEARCH,CANDIDATE_DELETE ,CANDIDATE_SEARCHLIST,GET_SEARCH_DATA ,GET_MAPPED_CANDIDATE_DATA ,GET_SEARCH_MAPPED_CANDIDATE_DATA, GET_SEARCH_FILTER_CANDIDATE_DATA, GET_SEARCH_SUGGESTION_DATA,
  GET_SEARCH_TABLE_SUGGESTION_DATA,
  GET_TABLE_SEARCH_FILTER} from "./actionTypes"
import { candidateListSuccessful, candidateListFailed ,candidateSearchListFailed,candidateSearchListSuccessful,deleteCandidateFailed,deleteCandidateSuccessful ,
  candidatesearchlistSuccess,candidatesearchlistFailed, getSearchSuggestionDataFailed, getSearchSuggestionDataSuccess} from "./actions"

import {candidateSearchList, deleteCandidates ,getRequest } from "../../../../../helpers/fakebackend_helper"

//restapi end point
import * as constClass from "../../../../../common/constant/constantURL"

// get candidate list
function* getCandidateList({ payload: { user } }) {
  try 
  {
    let url=constClass.REST_API_GET_CANDIDATE_LIST+`?page=${user.page}&pageSize=${user.pageSize}&type=${user.type}`;
    //calling candidate list api
    let responsJSON = yield call(getRequest, url);
    yield put(candidateListSuccessful(responsJSON))
  } 
  catch (error) 
  {
    yield put(candidateListFailed(error))
  }
}

// get search candidate list
function* getSearchList({ payload: { user } }) {
  try 
  {
    let url=constClass.REST_API_SEARCH_CANDIDATE_LIST;
    //calling candidate list api
    let responsJSON = yield call(candidateSearchList, url, user);
    yield put(candidateSearchListSuccessful(responsJSON))
  } 
  catch (error) 
  {
    yield put(candidateSearchListFailed(error))
  }
}

//Candidate Delete
function* deleteCandidate({ payload: { user ,history} }) {

  try 
  {
    let obj={}
    obj["candidateId"] =user
    let url=constClass.REST_API_ADD_DELETE_CANDIDATE;
    //calling candidate list api
    let responsJSON = yield call(deleteCandidates, url, obj);
    yield put(deleteCandidateSuccessful(responsJSON))
   
  } 
  catch (error) 
  {
    yield put(deleteCandidateFailed(error))
  }
}


//candidate search listing 
function* candidatesearchlist({ payload: { user } }) {
  try {
    let url;
      url=constClass.CADIDATE_SEARCH_URL+user.request
    let responsJSON = yield call(getRequest, url);
    yield put(candidatesearchlistSuccess(responsJSON))
  }
  catch (error) {

    yield put(candidatesearchlistFailed(error))
  }
}

//candidate normal search listing 
function* getSearchData({ payload: { user } }) {
  try {
    let url;
      url=constClass.CANDIDATE_NORMAL_SEARCH +`${user.page}?indexType=${user.indexType}&keyword=${user.keyword}&pageSize=${user.pageSize}`;
    let responsJSON = yield call(getRequest, url);
    yield put(candidatesearchlistSuccess(responsJSON))
  }
  catch (error) {

    yield put(candidatesearchlistFailed(error))
  }
}

// get Mapped candidate list
function* mappedCandidateList({ payload: { user } }) {
  try 
  {
    let url=constClass.REST_API_GET_MAPPED_CANDIDATE_LIST+`${user.page}`;
    let responsJSON = yield call(getRequest, url);
    yield put(candidateListSuccessful(responsJSON))
  } 
  catch (error) 
  {
    yield put(candidateListFailed(error))
  }
}
// get Search keyword in Mapped candidate list
function* getMappedSearchData({ payload: { user } }) {
  try 
  {
    let url=constClass.APPLIED_CANDIDATE_NORMAL_SEARCH+`${user.page}?keyword=${user.keyword}`;
    let responsJSON = yield call(getRequest, url);
    yield put(candidateListSuccessful(responsJSON))
  } 
  catch (error) 
  {
    yield put(candidateListFailed(error))
  }
}
// get Search keyword in filter candidate list
function* getFilterSearchData({ payload: { user } }) {
  try 
  {
    let url =  constClass.CANDIDATE_NORMAL_SEARCH+`${user.pageStart}?`
      url =  url+`indexType=Resume${user.query.keyword ? "&keyword="+user.query.keyword : ""}&pageSize=${user.pageSize ? user.pageSize : 10}`;
    if(user.resumeAge !== undefined && user.resumeAge !== null){
      url +=`&dateRange=${user.resumeAge+" "+user.resumeAgetype}`
    }
    if(user.filter.Skill !== undefined && user.filter.Skill !== null){
      url +=`&skillFacets=${ user.filter.Skill.toString()}`
    } 
    if(user.filter.JobProfile !== undefined && user.filter.JobProfile !== null){
      url +=`&jobProfileFacets=${ user.filter.JobProfile.toString()}`
    }
    if(user.filter.Location !== undefined && user.filter.Location !== null){
      url +=`&locationFacets=${ user.filter.Location.toString()}`
    }
      if(user.filter.Education !== undefined && user.filter.Education  !== null){
      url +=`&educationFacets=${ user.filter.Education.toString()}`
    } 
    if(user.Experience!== undefined && user.Experience!== null){
      url +=`&experienceFacets=${ user.Experience.toString()}`
    }

    let url2 = ""
    if(user.boolanFilter !== undefined && user.boolanFilter !== null && user.boolanFilter !== ""){
        user?.boolanFilter.map(eachObject=>{
        return url2 +=eachObject.filterName+"Required="+encodeURIComponent(eachObject.value)+"&"
      })
  
      url += `&${url2.slice(0, url2.length-1)}`
    }
    let responsJSON = yield call(getRequest, url);
    yield put(candidatesearchlistSuccess(responsJSON))
  }
  catch (error) {

    yield put(candidatesearchlistFailed(error))
  }
}


function* getTableFIlterSearch({payload: {user, customData}}){
  try{
    let url =  constClass.CANDIDATE_BOOLEAN_SEARCH +`?page=${user.pageNumber}&pageSize=${user.pageSize}&indexType=Resume`
   let url2 = ""
    user?.filter.map(eachObject=>{
      return url2 +=eachObject.filterName+"Required="+encodeURIComponent(eachObject.value)+"&"
    })

    url2 = url2.slice(0, url2.length-1)
    let responsJSON = yield call(getRequest, url+`&${url2}`);
    yield put(candidatesearchlistSuccess(responsJSON))
  }
  catch (error){
    yield put(candidatesearchlistFailed(error))
  }
}


function* getSearchSuggestionData ({payload : {user}}){
try{

  let url = constClass.SEARCH_SUGGESTION_DATA+`/?q=${user}`;
  let responsJSON = yield call( getRequest , url)
  yield put (getSearchSuggestionDataSuccess(responsJSON))
}catch(error){
yield put(getSearchSuggestionDataFailed(error))
}
}

function* getTableSuggestionData({payload: {user}}){
  try{
    let url = constClass.SEARCH_TABLE_SUGGESTION_DATA
    if(!user.isSearch){
       url = url+`?keyword=${user.keyword}&category=${user.column}`
    }
    else{
      url = constClass.SEARCH_SUGGESTION_DATA+`/?q=${user.keyword}`
    }
    let responsJSON = yield call( getRequest , url)
    yield put (getSearchSuggestionDataSuccess(responsJSON))
  }catch(error){
  yield put(getSearchSuggestionDataFailed(error))
  }
}

export function* watchCandidateList() {
  yield takeEvery(CANDIDATE_LIST, getCandidateList);
  yield takeEvery(CANDIDATE_SEARCH, getSearchList);
  yield takeEvery(CANDIDATE_DELETE, deleteCandidate)
  yield takeEvery(CANDIDATE_SEARCHLIST, candidatesearchlist)
  yield takeEvery(GET_SEARCH_DATA, getSearchData)
  yield takeEvery(GET_MAPPED_CANDIDATE_DATA, mappedCandidateList)
  yield takeEvery(GET_SEARCH_MAPPED_CANDIDATE_DATA, getMappedSearchData)
  yield takeLatest(GET_SEARCH_FILTER_CANDIDATE_DATA, getFilterSearchData)
  yield takeLatest(GET_SEARCH_SUGGESTION_DATA, getSearchSuggestionData)
  yield takeLatest(GET_TABLE_SEARCH_FILTER, getTableFIlterSearch)
  yield takeEvery( GET_SEARCH_TABLE_SUGGESTION_DATA, getTableSuggestionData)

}

function* candidateListSaga() {
  yield all([fork(watchCandidateList)]);
 
}

export default candidateListSaga